import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, ButtonSize, PagePanel } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useDispatch } from 'react-redux';

import { ICardOrderSuccessfulScreen } from '@epi-models/containers/OrderStatus';
import { useMenuDimensions, useOnboardingWizard } from '@epi-shared/hooks';
import { getUserCompany } from '@epi-actions/api';

import { PaymentMethods } from '../../constants/paymentMethods';
import { routerPaths } from '../../constants/routerPaths';

export const CardOrderSuccessfulScreen = ({
  isPaymentSuccess,
  getTranslationPath,
  paymentMethod,
  goToPage,
  footer
}: ICardOrderSuccessfulScreen) => {
  const { t } = useTranslation();
  const { isMobile } = useMenuDimensions();
  const { fontSize } = useTheme();
  const dispatch = useDispatch();
  const { isOnBoardingActive } = useOnboardingWizard();
  const redirectToReports = () => {
    goToPage(routerPaths.reportsDeposits);
  };

  const getTitle = () =>
    t(
      getTranslationPath(
        paymentMethod === PaymentMethods.EInvoice ||
          paymentMethod === PaymentMethods.PdfInvoice
          ? `title_success_${paymentMethod}`
          : 'title_success',
        isPaymentSuccess
      )
    );

  const getBody = () =>
    t(
      getTranslationPath(
        paymentMethod === PaymentMethods.EInvoice ||
          paymentMethod === PaymentMethods.PdfInvoice
          ? `body_success_${paymentMethod}`
          : 'body_success',
        isPaymentSuccess
      )
    );

  useEffect(() => {
    dispatch(getUserCompany());
  }, []);

  return (
    <PagePanel footer={footer} title={getTitle()}>
      <Box fontSize={fontSize} py={2}>
        {getBody()}
      </Box>
      {paymentMethod === PaymentMethods.PrintInvoicePdf && (
        <h2 className="small">
          {t('containers.order_status.body_reference_number_info')}
        </h2>
      )}
      <Box
        display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        gap={3}
        mt={3}
      >
        {!isOnBoardingActive && (
          <Button
            id="go-to-transactions-history-btn"
            size={ButtonSize.Medium}
            onClick={redirectToReports}
          >
            {t(getTranslationPath('button_success'))}
          </Button>
        )}
      </Box>
    </PagePanel>
  );
};
